<template>
  <b-card body-class="py-3" class="card-box card__evaluation-score w-100 mx-auto">
    <div class="row__card-header">
      <p class="font-weight-bold m-0">Overall Evaluation</p>
      <b-spinner v-if="isUpdating" variant="primary" small />
      <b-button
        v-else-if="!quotaEmpty"
        variant="outline-primary"
        @click="$emit('update-submission')"
      >
        Review & Edit
      </b-button>
    </div>
    <div class="row__card-scroll">
      <div class="w-100 card-evaluation card-total">
        <p class="m-0 card-total-title">Total Part</p>
        <div id="num" class="card-total-value">{{ totalPosts }}</div>
      </div>
      <div class="w-100 card-evaluation card-pass">
        <p class="m-0 card-pass-title">Pass</p>
        <div class="card-pass-value">{{ passedPosts }}</div>
      </div>
      <div class="w-100 card-evaluation card-fail">
        <p class="m-0 card-fail-title">Need Improvement</p>
        <div class="card-fail-value">{{ deniedPosts }}</div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    passedPosts: {
      type: Number,
      default: 0
    },
    deniedPosts: {
      type: Number,
      default: 0
    },
    quotaEmpty: {
      type: Boolean,
      default: false
    },
    isUpdating: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    totalPosts() {
      return this.passedPosts + this.deniedPosts;
    }
  }
};
</script>

<style lang="scss" scoped>
.card__evaluation-score {
  max-width: 910px;

  .row__card-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
  }
  .row__card-scroll {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .card-evaluation {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    border-radius: 12px;

    .card-total-value,
    .card-pass-value,
    .card-fail-value {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .card-total {
    border: 1px solid #d1d2db;
  }

  .card-pass {
    background-color: #cff3f8;
    border: 1px solid #bceff5;
    color: #0c6b7e;
  }

  .card-fail {
    background-color: #fed6da;
    border: 1px solid #fdc6cb;
    color: #7e2a0c;
  }

  @media screen and (min-width: 576px) {
    .row__card-scroll {
      flex-direction: row;
    }
  }
}
</style>
